import {Lang, LangUtil} from 'yougile-lang'
import {Util} from 'yougile-util'
import {getAllHelpTopics} from './api-help-data'

export class HelpNode {
  public name: string
  public display: string
  public code: string
  public example: string
  public description: string
  public descriptionRu: string
  public fields: HelpNode[]
  public parent: HelpNode
  public isVar: boolean

  constructor(
    name: string,
    display: string,
    code: string,
    example: string,
    description: string,
    descriptionRu: string,
    fields: HelpNode[] = []
  ) {
    this.name = name
    this.display = display
    this.code = Util.removeLeadingNewline(LangUtil.stripMargin(code))
    this.example = Util.removeLeadingNewline(LangUtil.stripMargin(example))

    this.description = description
    this.descriptionRu = descriptionRu
    this.fields = fields
    this.isVar = display.includes('variable')
    if (fields) {
      fields.forEach((f: HelpNode) => (f.parent = this))
    }
  }

  public describe(): string {
    return Lang.getLang() === 'ru' ? this.descriptionRu : this.description
  }
}

export class ApiHelp {
  public static getAllObjects(): HelpNode[] {
    return getAllHelpTopics()
  }
}
